import { FC } from "react";

export interface HeaderBarButtonProps {
  icon: string;
  onClick: () => void;
  text: string;
  disabled?: boolean;
  title?: string;
}

const HeaderBarButton: FC<HeaderBarButtonProps> = ({ icon, onClick, text, disabled, title }) => {
  return (
    <button
      style={{
        // Buttonlink
        background: "none",
        border: "none",
        padding: 0,
        font: "inherit",
        cursor: disabled ? "default" : "pointer",

        maxWidth: "250px",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        fontSize: "1.25em",
        opacity: disabled ? "0.5" : "1",
      }}
      title={title || text}
      onClick={onClick}
      disabled={disabled}
    >
      <i className={`fa fa-${icon}`} style={{ paddingRight: "0.5rem" }} />
      {text}
    </button>
  );
};

export default HeaderBarButton;
